import * as React from "react"
import { Slot } from "@radix-ui/react-slot"
import { cva } from "class-variance-authority";

import { cn } from "@/lib/utils"

const buttonVariants = cva(
  "inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-[6px] text-[13px] font-medium transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0",
  {
    variants: {
      variant: {
        default:
          "bg-[#0B1F3A] text-white hover:bg-[#1E293B]",
        destructive:
          "bg-[#B91C1C] text-white hover:bg-red-800",
        outline:
          "border border-[#E2E8F0] bg-transparent text-[#0B1F3A] hover:bg-[#F8FAFC]",
        secondary:
          "bg-[#F8FAFC] text-[#0B1F3A] border border-[#E2E8F0] hover:bg-[#F1F5F9]",
        ghost: "text-[#0B1F3A] hover:bg-[#F8FAFC] hover:text-[#0B1F3A]",
        link: "text-[#0B1F3A] underline-offset-4 hover:underline",
        accent: "bg-[#C9A227] text-[#0B1F3A] font-semibold hover:bg-[#b8911f]",
      },
      size: {
        default: "h-8 px-4 py-0",
        sm: "h-7 rounded-[4px] px-3 text-[12px]",
        lg: "h-9 rounded-[6px] px-6",
        icon: "h-8 w-8",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
    },
  }
)

const Button = React.forwardRef(({ className, variant, size, asChild = false, ...props }, ref) => {
  const Comp = asChild ? Slot : "button"
  return (
    <Comp
      className={cn(buttonVariants({ variant, size, className }))}
      ref={ref}
      {...props} />
  );
})
Button.displayName = "Button"

export { Button, buttonVariants }
